import { Injector } from '@angular/core'

import { CookieNotificationService } from './cookie-notification.service'

export type { CookieNotificationService } from './cookie-notification.service'

export async function importCookieNotificationService(inj: Injector): Promise<CookieNotificationService> {
  const m = await import('./cookie-notification.service')
  const ci = Injector.create({ parent: inj, providers: [m.CookieNotificationService] })
  return ci.get(m.CookieNotificationService)
}
